import { render } from "./Terminals.vue?vue&type=template&id=5c0323c3"
import script from "./Terminals.vue?vue&type=script&lang=js"
export * from "./Terminals.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__